import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import { Form } from 'formsy-react-2'
import { push } from 'react-router-redux'
import moment from 'moment'
import { Button, Checkbox, Modal, InputTag, Select, TextInput, DatePicker } from 'advenio-components'
import styled from 'styled-components'

const ConsumibleCate = styled.div`
  width: 50%;
`
const SelectContainer = styled.div`
  width: 38%;
  display:inline-block;
  ${({ extra_total }) => extra_total && `
   width:222px;
   margin: -10px 3px;
  `}
`
const InputContainer = styled.div`
  margin-bottom: 15px;
  ${({ extra_total }) => extra_total && `
    width:166px;
    margin: -10px 3px;
    display:inline-block;
  `}
`
const ButtonContainer = styled.div`
    position: absolute;  
    margin: -67px 465px;
`
const HiddenInputContainer = styled.div`
  display: none;
`
class ConsuimblesCategoryDetails extends Component {
  state = {
    isWithSupport: false,
  }


  render() {
    const { product, indexProduct, index, extra, deleteExtra, category, handledChange } = this.props
    return (
      <ConsumibleCate index={index} >
        <SelectContainer extra_total>
          <Select
            required
            name={`products[${indexProduct}].extra_support.${index}.consumable_type_id`}
            label="Categoria de Consumibles"
            options={category}
            value={extra.consumable_type_id}
            // onChangeCallback = {(e)=> {handledChange(e)}}
            // placeholder="Selecciona una Categoria de consumible"
          />
        </SelectContainer>
        <InputContainer extra_total>
          <TextInput
            type="text"
            name={`products[${indexProduct}].extra_support.${index}.total`}
            label="Monto Aportar"
            value={extra.total}
            validations="isNumeric"
            validationErrors={{ isNumeric: 'Debe ser un númerico' }}
            // onChangeCallback = {(e)=> {handledChange(e)}}
          />
        </InputContainer>
        <HiddenInputContainer >
          <TextInput
            type="text"
            name={`products[${indexProduct}].extra_support.${index}.support_as_pct`}
            label="Monto Aportar"
            value={0}
            readOnly
            validations="isNumeric"
          />
        </HiddenInputContainer>
        <ButtonContainer>
          <Button danger small onClick={(e) => { deleteExtra(indexProduct, index) }} >Borrar</Button>
        </ButtonContainer>
      </ConsumibleCate>
    )
  }
}
const mapStateToProps = state => ({
  consumiblesCategory: state.consumiblesCategory.get.results,
})

const mapDispatchToProps = dispatch => ({
})
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConsuimblesCategoryDetails))



// WEBPACK FOOTER //
// ./src/Containers/AddContract/ConsuimblesCategoryDetails.jsx